import Marquee from "react-fast-marquee";

export default function MarqueeBand() {
  const items = ["IMPERMEABILIZZAZIONE", "COIBENTAZIONE", "RISTRUTTURAZIONI CHIAVI IN MANO", "POLIUREA", "POLIURETANO"];
  return (
    <div
      data-testid="marquee-band"
      className="py-6 border-y bg-primary border-primary"
    >
      <Marquee speed={40} gradient={false}>
        {items.concat(items).map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-head font-black text-3xl md:text-5xl tracking-tightest text-primary-foreground">
              {t}
            </span>
            <span className="mx-8 text-3xl md:text-5xl text-primary-foreground/50">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
